import React, { FC } from 'react';
import { PublicJobDetailBox } from '../../../../../../../ReactSharedScripts/modules/publicJob/detail/components/PublicJobDetailBox';
import { PaddingBox } from '../../../../../../../ReactSharedScripts/components/PaddingBox';
import { PublicJobDetailTitle } from '../../../../../../../ReactSharedScripts/modules/publicJob/detail/components/PublicJobDetailTitle';
import { PublicJobDetailForm } from '../../../../../../../ReactSharedScripts/modules/publicJob/detail/components/PublicJobDetailForm';
import { usePublicJobDetailDataQuery } from '../../../../../../../ReactSharedScripts/modules/publicJob/detail/hooks';
import { isBadOrEmptyString } from '../../../../../../../ReactSharedScripts/predicates/string';
import PreviewFieldHTML from '../../../../../../../ReactSharedScripts/components/PreviewField/PreviewFieldHTML';
import { PublicJobDetailMetadata } from '../../../../../../../ReactSharedScripts/modules/publicJob/detail/components/PublicJobDetailMetadata';

export const PublicJobDetailCard: FC = () => {
	const {
		data: { description },
	} = usePublicJobDetailDataQuery();
	return (
		<PublicJobDetailBox>
			<PaddingBox small>
				<PaddingBox bottomTiny>
					<PublicJobDetailTitle fontSize={28} />
				</PaddingBox>
				<PaddingBox bottomMedium>
					<PublicJobDetailMetadata />
				</PaddingBox>
				<PublicJobDetailForm />
				{!isBadOrEmptyString(description) && (
					<PaddingBox topMedium>
						<PreviewFieldHTML value={description} />
					</PaddingBox>
				)}
			</PaddingBox>
		</PublicJobDetailBox>
	);
};
